<template>
  <span
    v-if="type?.toLowerCase() === 'suspended'"
    class="rounded-md px-3 text-sm py-1 text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >Suspended</span
  >

  <span
    v-if="type?.toLowerCase() === 'active' || type?.toLowerCase() === 'unused'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >{{
      type?.toLowerCase() === "active"
        ? "Active"
        : type?.toLowerCase() === "unused"
        ? "Unused"
        : ""
    }}</span
  >
  <span
    v-if="type?.toLowerCase() === 'approved'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--green100)] bg-[var(--green50)] font-semibold"
    >Approved</span
  >
  <span
    v-if="type?.toLowerCase() === 'pending'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--yellow100)] bg-[var(--yellow50)] font-semibold"
    >Pending</span
  >
  <span
    v-if="
      type?.toLowerCase() === 'expired' || type?.toLowerCase() === 'declined'
    "
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >{{
      type?.toLowerCase() === "expired"
        ? "Expired"
        : type?.toLowerCase() === "declined"
        ? "Declined"
        : ""
    }}</span
  >
  <span
    v-if="type?.toLowerCase() === 'used'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >Used</span
  >
  <span
    v-if="type?.toLowerCase() === 'deleted'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--red100)] bg-[var(--red50)] font-semibold"
    >Deleted</span
  >
  <span v-if="type?.toLowerCase() === 'awaiting approval'"
    class="px-3 text-sm py-1 ml-1 rounded-md text-[var(--white100)] bg-[var(--black50)] font-semibold"
    >
    Awaiting approval
  </span>
</template>

<script>
export default {
  name: "StatusTag",
  props: ["type"],
};
</script>

<style></style>
